/**
 * Removes the Bearer prefix from a token if present. Used when storing the token.
 * Handles various formats: "Bearer token", "Bearer%20token", "bearer token"
 * @param {string} token - The token that may have a Bearer prefix
 * @returns {string} - Token without Bearer prefix
 */
export function removeBearerPrefix<T extends string | undefined | null>(
  token: T
) {
  if (!token) return token;
  if (token.toLowerCase().startsWith('bearer%20')) {
    return token.substring('bearer%20'.length);
  }
  if (token.toLowerCase().startsWith('bearer ')) {
    return token.substring('bearer '.length);
  }
  if (token.toLowerCase().startsWith('bearer+')) {
    return token.substring('bearer+'.length);
  }
  return token;
}

/**
 * Ensures the token has a Bearer prefix (used in headers)
 * A generic type is used so that if the invoker passed in a truthy string, the
 * return type is also a string.
 * @param {string} token - The token that may or may not have a Bearer prefix
 * @returns {string} - Token with Bearer prefix
 */
export function ensureBearerPrefix<T extends string | undefined | null>(
  token: T
) {
  if (!token) return token;
  if (token.toLowerCase().startsWith('bearer'))
    return `Bearer ${removeBearerPrefix(token)}`;
  return `Bearer ${token}`;
}
